import { render, staticRenderFns } from "./ResearchHotspotsEvolution.vue?vue&type=template&id=1aaae5ca&scoped=true"
import script from "./ResearchHotspotsEvolution.vue?vue&type=script&lang=js"
export * from "./ResearchHotspotsEvolution.vue?vue&type=script&lang=js"
import style0 from "./ResearchHotspotsEvolution.vue?vue&type=style&index=0&id=1aaae5ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaae5ca",
  null
  
)

export default component.exports